module.exports = __webpack_public_path__ + "assets/img/facebook.4570293a.svg";